<template>
  <div class="upload-imgs-box">
    <el-upload ref="upload" class="upload-demo" :action="uploadUrl" :headers="header" name="upload[]"
      :on-remove="handleRemove" :before-remove="beforeRemove" :on-success="handleAvatarSuccess" :on-error="uploadError"
      :before-upload="beforeAvatarUpload" accept="image/jpeg, image/png, image/jpg" :on-exceed="handleExceed"
      list-type="picture-card" multiple :limit="150" :file-list="fileList">
      <div class="el-upload-list__item" slot="file" slot-scope="{file}">
        <img-load class="el-upload-list__item-thumbnail" :src="file.url" :preview-src-list="previewSrcList" alt="" />
        <span class="el-upload-list__item-actions">
          <span class="el-upload-list__item-preview" @click="handlePreview(file)">
            <i class="el-icon-zoom-in"></i>
          </span>
          <span class="el-upload-list__item-delete" @click="beforeRemove(file)">
            <i class="el-icon-delete"></i>
          </span>
        </span>
      </div>
      <el-button size="small" class="btnPics" type="success">选取图片</el-button>
      <div slot="tip" v-if="!notLimit" class="tip">只能上传jpg、png、gif格式，大小不超过500KB的图片</div>
    </el-upload>
  </div>
</template>

<script>
import baseConfig from "@/utils/serverUrlConfig";
import local from "@/utils/localStroage";
import previewImages from "@/utils/previewImages";

export default {
  props: ["cover", "width", "height", "id", "wSize", "hSize", "hide", "notLimit", 'value'],
  data() {
    return {
      fileList: [],
      imgUrl: baseConfig.imgUrl,
      uploadUrl: baseConfig.baseServerUrl + "/comm/uploadStaticBatch",
      cropperModel: false,
      // 当前选中的文件（未压缩裁剪之前）
      checkedFile: "",
      header: {
        Authorization: local.get("userInfo").token,
      },
    };
  },
  computed: {
    previewSrcList() {
      const urls = this.fileList.map(v => v.url)
      return urls
    }
  },
  watch: {
    value: {
      handler(val) {
        if (this.fileList.length > 0) return
        if (!Array.isArray(val)) return;
        this.fileList = val.map(v => ({ url: baseConfig.imgUrl + v, status: 'success' }))
      },
      immediate: true
    }
  },
  methods: {
    //移除图片
    // eslint-disable-next-line no-unused-vars
    handleRemove(file, fileList) {
      this.inputFileList(fileList);
    },
    // eslint-disable-next-line no-unused-vars
    handlePreview(file) {
      previewImages(this.previewSrcList, file.url)
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 150 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    // eslint-disable-next-line no-unused-vars
    async beforeRemove(file) {
      try {
        await this.$confirm(`确定移除 ${file.name || ''}？`);
        this.fileList.splice(this.fileList.indexOf(file), 1)
        this.handleRemove(file, this.fileList)
      } catch (error) {
        console.error('remove error:', error);
      }
    },
    // 图片上传前验证
    beforeAvatarUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 0.5;
      if (!isLt3M && !this.notLimit) {
        this.$message.error("图片上传大小不能超过500kb");
        return false;
      }
    },
    //图片上传成功回调
    // eslint-disable-next-line no-unused-vars
    handleAvatarSuccess(response, file, fileList) {
      this.fileList = fileList
      this.inputFileList(fileList);
    },
    inputFileList(fileList) {
      const urls = []
      fileList.forEach((e) => {
        if (e.status === 'success') {
          // 处理后台返回的值
          urls.push(e.response ? e.response.data.filePath[0] : e.url.slice(baseConfig.imgUrl.length));
        }
      });
      this.$emit('input', urls);
      this.$emit("successCallback", urls);
    },
    //图片上传错误
    uploadError() {
      this.$message.error("上传封面图失败");
    },
    // 清除图片
    clearImg() {
      this.$refs.upload.clearFiles();
      this.fileList = []
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-imgs-box {
  width: 100%;

  .tip {
    margin-top: 10px;
    font-size: 12px;
    color: #999;
    line-height: normal;
  }
  .el-upload-list__item {
    &-thumbnail {
      object-fit: contain;
    }
  }

  /deep/ .el-upload {
    width: 200px !important;
    height: 100px !important;

    .btnPics {
      position: relative;
      top: -25px;
      left: 0px;
    }
  }

  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 100px !important;
    height: 100px !important;

    img {
      object-fit: contain;
    }
  }
}
</style>
